import { cn } from '@/lib/utils'

/** Layered copies are decorative; each word is announced once. */
export function PlayHeadline({ words, className }: { words: string[]; className?: string }) {
  return (
    <span className={cn('play-headline', className)}>
      {words.map((word, index) => (
        <span className="play-headline__word" key={`${word}-${index}`}>
          {[5, 4, 3, 2, 1].map((layer) => <span key={layer} className={`play-headline__layer play-headline__layer--${layer}`} aria-hidden="true">{word}</span>)}
          <span className="play-headline__face">{word}</span>{' '}
        </span>
      ))}
    </span>
  )
}
